import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MainHeader from "../Common/MainHeader";
import Footer from "../Common/Footer";
import * as myConstList from "../Common/BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGAuthLoginMutation } from "../../redux/googleAuthApi";

const baseUrl = myConstList.baseUrl;

const GoogleAuthLogin = () => {
  const navigate = useHistory();
  const [vcode, setVcode] = useState("");
  const [codeErrMsg, setCodeErrMsg] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [gAuthLogin, { isLoading: loggingIn }] = useGAuthLoginMutation();

  useEffect(() => {
    const hem = localStorage.getItem("hemAuth");
    const pr = localStorage.getItem("pr");
    if (pr !== "ga" || !hem) {
      navigate.goBack();
    }
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and max 6 digits
    if (/^\d{0,6}$/.test(value)) {
      setVcode(value);
      if (value.length === 6) setCodeErrMsg(""); // clear error if valid
      if(!value) setCodeErrMsg("Verification code is required")
    }
  };

  const verifyCode = async () => {
    setBtnDisable(true);
    setTimeout(() => {
      setBtnDisable(false)
    },3000);
    if (!vcode.trim()) {
      setCodeErrMsg("Verification code is required");
      return;
    }
    if (vcode.trim().length !== 6) {
      setCodeErrMsg("Code must be 6 digits");
      return;
    }

    try {
      const payload = { code: vcode };
      const res = await gAuthLogin(payload);
      const { data, error } = res;

      // ✅ Navigate or handle success as per your API response
      if (error) {
        toast.error(error?.data?.message);
      }

      if (data?.status) {
        const user = data?.data?.[0] || {};
        const token = data?.token || "";

        localStorage.setItem("id", user.id || "");
        localStorage.setItem("mobile", user.mobile || "");
        localStorage.setItem("jwtToken", token);

        localStorage.removeItem("pr");
        localStorage.removeItem("hemAuth");
        toast.dismiss();
        toast.success("Login successfully");
        setTimeout(()=>{window.location.href = "/";},1000)
      }
    } catch (error) {
      setCodeErrMsg("Something went wrong");
      toast.error("Invalid 2FA Code");
    }
  };

  return (
    <div>
      <MainHeader />

      <div className="box5 p60">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-6 h-5 mt-md-5    ">
              <div className="boxbody login_box">
                <h4 className="tc mb-4">2FA Verification</h4>
                <div className="form-group">
                  <label className="fw-500">Enter 6-digit Auth Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="vcode"
                    placeholder=""
                    value={vcode}
                    onChange={handleChange}
                    maxLength={6}
                    inputMode="numeric"
                    autoFocus
                  />
                  {codeErrMsg && (
                    <div className="form-group">
                      <small style={{ color: "red" }}>{codeErrMsg}</small>
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <button
                    onClick={verifyCode}
                    className="btn btn_man w100px"
                    disabled={btnDisable}
                  >
                    {loggingIn ? "Verifying..." : "Verify"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      
    </div>
  );
};

export default GoogleAuthLogin;
